module.exports = __webpack_public_path__ + "static/media/panel.acea81f8.png";